import _ from 'lodash';
import { Validator } from 'modules/core';

function validateProfileDetails(values) {
  const firstNameError = Validator.validateName(values.firstName, 'First name');
  const lastNameError = Validator.validateName(values.lastName, 'Last name');
  const professionalHeadlineError =
    Validator.validateUserText(
      values.professionalHeadline,
      'Professional Tagline/Title',
    ) ||
    Validator.validateStringLength(
      values.professionalHeadline,
      { min: 2 },
      'Professional Tagline/Title',
    );
  const companyError = Validator.validateUserText(
    values.organizationName,
    'Company',
  );
  const cityError = Validator.validateUserText(values.city, 'City');
  const zipError = Validator.validateUserText(values.zipCode, 'Zip code');
  const shortBioError =
    Validator.validateUserText(values.shortBio, 'Biography') ||
    Validator.validateStringLength(values.shortBio, { min: 50 }, 'Biography');

  return {
    ...(firstNameError && { firstName: firstNameError }),
    ...(lastNameError && { lastName: lastNameError }),
    ...(professionalHeadlineError && {
      professionalHeadline: professionalHeadlineError,
    }),
    ...(companyError && { organizationName: companyError }),
    ...(cityError && { city: cityError }),
    ...(zipError && { zipCode: zipError }),
    ...(shortBioError && { shortBio: shortBioError }),
  };
}

function validateSocialLinks(producer) {
  const socialMediaLinks = _.pick(producer, [
    'facebookLink',
    'instagramLink',
    'twitterLink',
    'linkedinLink',
    'imdbLink',
  ]);

  return _.reduce(
    socialMediaLinks,
    (result, link, name) => {
      if (_.isEmpty(link)) {
        return result;
      }
      const socialMedia = name.slice(0, -4); // instagramLink => instagram
      const linkError = Validator.validateLink(link, socialMedia);
      if (linkError) {
        // eslint-disable-next-line no-param-reassign
        result[name] = linkError;
      }
      return result;
    },
    {},
  );
}

export default {
  validateSocialLinks,
  validateProfileDetails,
};
